import React from 'react';
import { Link } from 'react-router-dom';
import { publicPath } from '../../utils/canonicalUrl';
import PublicSEO from '../../components/public/PublicSEO';
import './StatusPages.css';

const GonePage = () => (
  <div className="vc-status-page">
    <PublicSEO
      title="Contenuto non disponibile"
      description="La pagina richiesta non e piu disponibile."
      noIndex
    />
    <div className="container vc-status-page-inner">
      <p className="vc-status-code">410</p>
      <h1>Contenuto non piu disponibile</h1>
      <p>
        Questa pagina apparteneva al vecchio sito o non e piu presente. Per evitare risultati obsoleti nei motori di
        ricerca, il contenuto viene segnalato come rimosso.
      </p>
      <div className="vc-status-actions">
        <Link to="/" className="vc-btn vc-btn-primary">Torna alla home</Link>
        <Link to={publicPath('/medici')} className="vc-btn vc-btn-outline">Cerca un medico</Link>
      </div>
    </div>
  </div>
);

export default GonePage;
